import { render, staticRenderFns } from "./DocumentRecordGrid.vue?vue&type=template&id=7bea7da0"
import script from "./DocumentRecordGrid.vue?vue&type=script&lang=js"
export * from "./DocumentRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports